import React from "react";
import PAScreeningSection from "./formSections/PAScreeningSection";
import PAPermissionOnline from "./formSections/PAPermissionOnline";
import PASecurityLoginSection from "./formSections/PASecurityLoginSection";
import PersonalInfoSection from "./formSections/PersonalInfoSection";
import ContactInfoSection from "./formSections/ContactInfoSection";
import CompanyInfoSection from "./formSections/CompanyInfoSection";
import CorrespondenceInfoSection from "./formSections/CorrespondenceInfoSection";
import PoliticallyExposedPerson from "./formSections/PoliticallyExposedPerson";
import CurrentPersonalDetails from "./formSections/CurrentPersonalDetails";
import { COUNTRY_NAME } from "../Common/constants";
import { useTranslation } from "react-i18next";
import { replaceEmptySpace } from "../Common/utils";
import RenderEuroFormSection from "./RenderEuroFormSection";

const EuroForm = ({ user, isModifyUser = false, formik }) => {
    const { t } = useTranslation('common');
    const swedenTranslated = t(`access.${replaceEmptySpace(COUNTRY_NAME.SWEDEN)}`) || COUNTRY_NAME.SWEDEN;
    const norwayTranslated = t(`access.${replaceEmptySpace(COUNTRY_NAME.NORWAY)}`) || COUNTRY_NAME.NORWAY;
    const iecTranslated = t(`access.${replaceEmptySpace(COUNTRY_NAME.INTERNATIONALEUROCARD)}`) || COUNTRY_NAME.INTERNATIONALEUROCARD;
    const { country } = user;

    const iecAdd = [
        PersonalInfoSection, PASecurityLoginSection, PAScreeningSection,
        ContactInfoSection,
        [CompanyInfoSection, CorrespondenceInfoSection],
    ];
    const iecModify = [
        PersonalInfoSection, PASecurityLoginSection, PAScreeningSection,
        ContactInfoSection,
        [CompanyInfoSection, CorrespondenceInfoSection],
    ];

    const swedenNorwayAdd = [
        PersonalInfoSection,
        PAScreeningSection,
        PASecurityLoginSection,
        ContactInfoSection,
        [CompanyInfoSection, CorrespondenceInfoSection],
        PoliticallyExposedPerson,
        PAPermissionOnline,
    ];

    const swedenNorwayModify = [
        CurrentPersonalDetails,
        CompanyInfoSection,
        PersonalInfoSection,
        PASecurityLoginSection,
        PAScreeningSection,
        [ContactInfoSection, CorrespondenceInfoSection],
    ];

    return (
        <>
            {(country === iecTranslated) && (
                !isModifyUser
                    ? RenderEuroFormSection(iecAdd, { formik, isModifyUser, country }, { id: 'country-iec-add' })
                    : RenderEuroFormSection(iecModify, { formik, isModifyUser, country }, { id: 'country-iec-modify', className: 'pad-2-t' })
            )}

            {(country === norwayTranslated) && (
                !isModifyUser
                    ? RenderEuroFormSection(swedenNorwayAdd, { formik, isModifyUser, country }, { id: 'country-norway-add' })
                    : RenderEuroFormSection(swedenNorwayModify, { formik, isModifyUser, country }, { id: 'country-norway-modify', className: 'pad-2-t' })
            )}

            {(country === swedenTranslated) && (
                !isModifyUser
                    ? RenderEuroFormSection(swedenNorwayAdd, { formik, isModifyUser, country }, { id: 'country-sweden-add' })
                    : RenderEuroFormSection(swedenNorwayModify, { formik, isModifyUser, country }, { id: 'country-sweden-modify', className: 'pad-2-t' })
            )}
        </>
    );
};

export default EuroForm;
